import "./PlantEquipmentHire.module.css";
import Header from "@/reusable_sections/Header";
import WhyChooseOurVenues from "./sections/WhyChooseOurVenues";
import StudentResources from "./sections/StudentResources";
import ServiceOverview from "./sections/ServiceOverview";
import Footer from "@/reusable_sections/Footer";
import ProductShowcase from "./sections/ProductShowcase";
export default function PlantEquipmentHirePage() {
  return <div>
      <Header />
      <WhyChooseOurVenues />
      <ProductShowcase />
      <StudentResources />
      <ServiceOverview />
      <Footer />
    </div>;
}